import type React from "react";
import { useState } from "react";
import { MatchingBuildings } from "./components/Buildings";
import { MatchingStaffs } from "./components/Staffs";

export const NewMatchingPage: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<"buildings" | "staffs">("staffs");
  const [staffShiftGroupId, setStaffShiftGroupId] = useState<string | null>(null);

  if (currentPage === "buildings" && staffShiftGroupId)
    return <MatchingBuildings staffShiftGroupId={staffShiftGroupId} />;
  return <MatchingStaffs setStaffShiftGroupId={setStaffShiftGroupId} setCurrentPage={setCurrentPage} />;
};
